/**
 * Comprime e redimensiona imagem antes do upload.
 * - Usa canvas para redimensionar para max 1600px (lado maior)
 * - Comprime para JPEG quality 0.85
 * - Reduz drasticamente tamanho (8MB iPhone -> ~400KB)
 *
 * NOTA: HEIC/HEIF do iPhone NAO sao decodificados pelo browser, entao retornamos
 * o arquivo original — o backend faz a conversao via pillow-heif.
 */
export async function compressImage(file, maxDimension = 1600, quality = 0.85) {
  // Skip compression for HEIC/HEIF (browser cant decode); send original to backend
  if (/\.(heic|heif)$/i.test(file.name) || /heic|heif/i.test(file.type || '')) {
    return file;
  }

  // Skip if already small (< 800KB)
  if (file.size < 800 * 1024) {
    return file;
  }

  try {
    const img = await new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const i = new Image();
      i.onload = () => { URL.revokeObjectURL(url); resolve(i); };
      i.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
      i.src = url;
    });

    const ratio = Math.min(maxDimension / img.width, maxDimension / img.height, 1);
    const w = Math.round(img.width * ratio);
    const h = Math.round(img.height * ratio);

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob) return file; // fallback
    return new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' });
  } catch (e) {
    console.warn('Compress failed, sending original:', e);
    return file;
  }
}
